import React from "react";
import Hero from "../components/Hero";
import About from "../components/About";
import Services from "../components/Services";
import HeroImage from "../../assets/images/AboutPage.jpg";
import ContentSection from "../components/ContentSection";
import MichealImage from "../../assets/images/About Page (2).jpg";
import AboutUsImage from "../../assets/images/About Page (3).jpg";

function AboutUsPage() {
  return (
    <>
      <Hero
        title={"ABOUT THE OWNER"}
        // subtitle={"Here at Ava Rose Mortgages, we are about helping you."}
        backgroundImage={HeroImage}
      />
      <ContentSection
        id="about us"
        // title="ABOUT US"
        paragraphs={[
          "",
          "My name is Michael Hunt owner and Managing Director of Ava Rose Mortgages Ltd.",
          "After 26 years working in tax advisory, primarily in the city of London, I made the decision to retrain and pursue a career where I could work more closely with people and make a direct impact on their financial wellbeing. Since September 2022, I have been a fully CeMAP qualified Mortgage and Protection Adviser, now proudly helping clients navigate some of the most important financial decisions of their lives. ",
        ]}
        image={MichealImage}
        imageAlt="Mortgage consultant"
        imagePosition="right"
        // buttonText="Start your journey with us"
        showDivider={true}
        backgroundColor="light"
      />
      <div className="footer-disclaimer  ">
        <div
          className="footer-Content Column
        "
        >
          <p>
            With a strong background in finance and tax accountancy, I bring a
            unique blend of technical knowledge and real‑world experience. My
            aim is simple, to use my expertise to guide both individuals and
            businesses toward the mortgage and protection solutions that meet
            their needs and those of their family.
          </p>
          <p>
            Over the years, I have had the privilege of helping clients from all
            walks of life, from first-time buyers taking their first big step on
            the housing ladder, to families looking to safeguard their future
            with the right protection plans. Ava Rose Mortgages’ goal is always
            the same, to make the process as clear, personal, and stress-free as
            possible. What sets us apart is our belief that good advice goes
            beyond numbers, it is about listening, understanding your goals, and
            finding solutions that fit your life, not the other way around
          </p>
        </div>
      </div>
      <ContentSection
        id="about us"
        // title="ABOUT US"
        paragraphs={[
          "",
          "Outside of work, l enjoy spending quality time with my family, making memories with my granddaughter, and appreciating the simple things in life. Those moments remind me of why the work I do matters, because behind every mortgage or insurance policy is a story, a family, and a future worth protecting.",
          "If you’re looking for honest, down-to-earth advice and someone who genuinely cares about helping you achieve your goals, I would love to hear from you.",
        ]}
        image={AboutUsImage}
        imageAlt="Mortgage consultant"
        imagePosition="left"
        // buttonText="Start your journey with us"
        showDivider={true}
        backgroundColor="light"
      />
    </>
  );
}

export default AboutUsPage;
